import { reactive, ref } from 'vue';
import { StoredViewport } from './stored-viewport';
import { filter_ip } from '@vaaas/fpts/array';
import { isnt } from '@vaaas/fpts/maths';

export const stored_viewports = reactive([] as StoredViewport[]);

export const showing_viewport_manager = ref(false);

export function show_viewport_manager() {
    showing_viewport_manager.value = true;
}

export function hide_viewport_manager() {
    showing_viewport_manager.value = false;
}

export function remove_a_viewport(x: StoredViewport) {
    filter_ip(isnt(x))(stored_viewports);
}
